import { axiosPrivate } from "./axios";

export const stripeApi = {
  // Create a trial payment intent
  createTrialPaymentIntent: async (paymentData) => {
    try {
      const response = await axiosPrivate.post(
        "/payment/create-trial-payment-intent",
        paymentData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create a one-time trial
  createOneTimeTrial: async () => {
    try {
      const response = await axiosPrivate.post(
        "/payment/create-one-time-trial"
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create a trial subscription
  createTrialSubscription: async (subscriptionData) => {
    try {
      const response = await axiosPrivate.post(
        "/payment/create-subscription-after-validation",
        subscriptionData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
